"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SourceButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const IconOnSteroid_1 = __importDefault(require("../IconOnSteroid"));
const AppText_1 = require("../AppText");
const colors_1 = require("../../common/colors");
;
function SourceButton({ icon, text, onPress }) {
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: onPress, onHoverIn: () => setIsHovered(true), onHoverOut: () => setIsHovered(false), style: [
            styles.container,
            isHovered && { backgroundColor: 'rgba(255, 255, 255, 0.20)' }
        ], children: (0, jsx_runtime_1.jsxs)(react_native_linear_gradient_1.default, { colors: ['rgba(69, 158, 202, 0.10)', 'rgba(1, 97, 167, 0.10)'], useAngle: true, angle: 96, locations: [0.0189, 0.9854], style: styles.gradient, children: [icon && ((0, jsx_runtime_1.jsx)(IconOnSteroid_1.default, { icon: icon, gradientColors: colors_1.Colors.CTA_GRADIENT_1, size: 12 })), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.text, children: text })] }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        backgroundColor: 'rgba(255, 255, 255, 0.10)',
        overflow: 'hidden',
        flex: 1,
        borderRadius: 19,
    },
    gradient: {
        gap: 8,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        paddingVertical: 9,
        paddingHorizontal: 16,
    },
    text: {
        color: '#FFF',
        lineHeight: 20,
    },
});
